// extracted by mini-css-extract-plugin
module.exports = {"personalInfo":"styles_personalInfo__2LEOs"};